import { addDaysYmd } from '../YhcEstimateFormFrontPage/masterVersionByDate'

/** SS/S 単独依頼を A ランク料金にするルールの開始日（当日を含む） */
export const SS_S_RANK_FEE_RULE_FROM = '2027-01-01'

export const SS_S_RANK_FEE_NOTE =
  '※2027年1月1日以降のお預かりの場合、SS・Sランクのみの配送はAランク料金となります（A〜Gランクと同時依頼時は従来どおり）。'

const YMD = /^\d{4}-\d{2}-\d{2}$/

const toYmd = (value: string | null | undefined): string => (value || '').slice(0, 10)

export const isOnOrAfterSsSRankFeeRule = (ymd: string | null | undefined): boolean => {
  const day = toYmd(ymd)
  return YMD.test(day) && day >= SS_S_RANK_FEE_RULE_FROM
}

/**
 * お届け日 D までに届くお預かり日を、D-1 から近い順に返す。
 * 14日前までに0件のときだけ、最大28日前まで遡って最初の1件を返す。
 */
export const listPickupDatesDeliveringBy = (params: {
  deliveryDate: string
  isWorkingDay: (ymd: string) => boolean
  deliveryDateForPickup: (pickupYmd: string) => string | null | undefined
}): string[] => {
  const deliveryDate = toYmd(params.deliveryDate)
  if (!YMD.test(deliveryDate)) return []

  const collect = (maxDays: number): string[] => {
    const results: string[] = []
    for (let i = 1; i <= maxDays; i++) {
      const pickupDate = addDaysYmd(deliveryDate, -i)
      if (!YMD.test(pickupDate) || !params.isWorkingDay(pickupDate)) continue
      const arrivesOn = toYmd(params.deliveryDateForPickup(pickupDate))
      if (!YMD.test(arrivesOn) || arrivesOn > deliveryDate) continue
      results.push(pickupDate)
    }
    return results
  }

  const within14 = collect(14)
  if (within14.length > 0) return within14

  const within28 = collect(28)
  return within28.length > 0 ? [within28[0]] : []
}

export type SsSRankFeeNoteInput = {
  dateMode: 'pickup' | 'delivery'
  pickupSelectedDate: string | null
  pickupDateResetFlag: boolean
  deliverySelectedDate: string | null
  deliveryDateResetFlag: boolean
  /** 画面に出しているお預かり可能日（E、および FG 利用可のとき FG） */
  availablePickupDates: string[]
  /** 当日自発着の案内を出しているとき true。繁忙期で不可のときは false */
  sameDayDeliveryAvailable: boolean
}

export const shouldShowSsSRankFeeNote = (input: SsSRankFeeNoteInput): boolean => {
  if (input.dateMode === 'delivery') {
    if (!input.deliverySelectedDate || input.deliveryDateResetFlag) return false
    if (input.availablePickupDates.some((date) => isOnOrAfterSsSRankFeeRule(date))) {
      return true
    }
    return (
      input.sameDayDeliveryAvailable &&
      isOnOrAfterSsSRankFeeRule(input.deliverySelectedDate)
    )
  }
  if (input.pickupDateResetFlag) return false
  return isOnOrAfterSsSRankFeeRule(input.pickupSelectedDate)
}
